import { FC, PropsWithChildren, StrictMode } from 'react';

import { TooltipProvider } from '@material-bank/mb-uikit/components/Tooltip';
import { UIKitProvider } from '@material-bank/mb-uikit/context';
import { MatchMediaProvider } from '@material-bank/mb-uikit/lib/css';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'theme-ui';

import { IntlProvider } from './IntlProvider';
import { SplitProvider } from './SplitProvider';
import { ToastsProvider } from './ToastsProvider';
import { useCreateQueryClient } from '../../shared/api';
import { CLOUDINARY_SETTINGS, theme } from '../../shared/config';
import { GenericLink } from '../GenericLink';
import { GlobalStyles } from '../GlobalStyles';

interface AppProvidersProps extends PropsWithChildren {
  enabledToastsProvider?: boolean;
}

export const AppProviders: FC<AppProvidersProps> = (props) => {
  const { enabledToastsProvider = true, children } = props;

  const queryClient = useCreateQueryClient();

  return (
    <StrictMode>
      <IntlProvider>
        <QueryClientProvider client={queryClient}>
          <SplitProvider>
            <ThemeProvider theme={theme}>
              <GlobalStyles />
              <MatchMediaProvider>
                <ToastsProvider enabled={enabledToastsProvider}>
                  <TooltipProvider>
                    <UIKitProvider
                      genericLink={GenericLink}
                      cloudinarySettings={CLOUDINARY_SETTINGS}
                    >
                      {children}
                    </UIKitProvider>
                  </TooltipProvider>
                </ToastsProvider>
              </MatchMediaProvider>
            </ThemeProvider>
          </SplitProvider>
        </QueryClientProvider>
      </IntlProvider>
    </StrictMode>
  );
};
